module.exports = __webpack_public_path__ + "static/media/etsy-icon.4f53e2f0.svg";